import { englishKeyboardOptions } from "./english"
import { thaiKeyboardOptions } from "./thai"
import { arabicKeyboardOptions } from "./arabic"
import { chineseKeyboardOptions } from "./chinese"
import { japaneseKeyboardOptions } from "./japanese"

export const keyboardOptions = {
  en: englishKeyboardOptions,
  th: thaiKeyboardOptions,
  ar: arabicKeyboardOptions,
  zh: chineseKeyboardOptions,
  ja: japaneseKeyboardOptions,
}
